import React from "react";
import { Card, Container, Row, Col, Accordion } from "react-bootstrap";

import "./faq.css";

export const Faq = () => {


    return (
        <>
            <Row className="fw-bolder mb-5 faqTitle align-content-center text-center">
                <Col>
                    <h1>FAQ</h1>
                    <p>Got Questions? We have the answers.</p>
                </Col>
            </Row>
            <Container className="pt-3 pb-3 mb-5 background justify-content-center rounded">
                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <Accordion>
                                    <h3 className="border-bottom border-warning border-5">Getting Started:</h3>
                                    <p className="text-center">To begin applying to jobs you can start by selecting a job and create an account in which you will
                                        need to fill out all or as much information as you can in concerns to personal information, education, and work history.</p>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            <p className="title">
                                                How do I create an account?
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <p className="title">To create an account.</p>
                                            <p>An account can be created by follow this link: <a target="_blank" rel="noopen noreferrer" href="/signup">Signup Page</a></p>
                                            <p className="title">Please Note:</p>
                                            <p>You will be required to sign up for an account using an email address that you have access to, as it
                                                will be utilized for notifications and verifying that you are who you say you are. </p>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            <p className="title">To apply for a job.</p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <ol>
                                                <li className="title mb-3">
                                                    Begin searching for a job.
                                                    <p className="normalText">
                                                        Follow the link to the jobs page, to view all current open positions. <a target="_blank" rel="noopen noreferrer" href="/jobs">Jobs Page</a>
                                                    </p>
                                                </li>
                                                <li className="title mb-3">
                                                    Choosing the right position.
                                                    <p className="normalText">
                                                        Search for a job from our extensive list of positions within the Navajo Nation.<br></br>
                                                        You can begin by going to the jobs page and take a browse or Search by Position, Location, Position Number, and Requisition ID.<br></br>
                                                        Furthermore you can sort by individual division or department.<br></br>
                                                        As you select a job from the list you can view detailed information on the position.<br></br>
                                                    </p>
                                                </li>
                                                <li className="title mb-3">
                                                    When you find the right position for you.
                                                    <p className="normalText">
                                                        You can click {"\"Apply\""} at the bottom of the position detail section and continue to apply for that position.
                                                    </p>
                                                </li>

                                                <li className="title border-top border-bottom mb-2">
                                                    Completing your profile.
                                                    <ul style={{ "list-style-type": "none" }} className="mb-2">
                                                        <li className="title list-spacing">
                                                            Why should you fill out your entire profile?
                                                        </li>
                                                        <p className="normalText m-0">
                                                            The information you provide on your profile will be utilized for your application, so filling
                                                            as much information as you can and please ensure all is accurate. The information that you provide
                                                            will be checked and verified, then credit will be assigned to determine your eligibility.
                                                        </p>
                                                        <li className="title list-spacing">
                                                            Upload fields.
                                                        </li>
                                                        <p className="normalText m-0">
                                                            You will need to upload an image or pdf of the document, certificate, degree, and transcripts. This will allow DPM to verify and provide credit for the information being provided.
                                                        </p>
                                                        <p className="title mb-0 fst-italic">
                                                            The following fields will require an image or pdf:
                                                        </p>
                                                        <ul>
                                                            <li>
                                                                <p className="normalText">
                                                                    Are you an enrolled member of the Navajo tribe?
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="normalText">
                                                                    Are you married to a Navajo tribal member?
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="normalText">
                                                                    Are you Unemployed due to Reduction in Force?
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="normalText">
                                                                    Are you a Veteran?
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="normalText">
                                                                    Do you have your Driver License details?
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="normalText">
                                                                    Do you have your High School education details?
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="normalText">
                                                                    Do you have your college details?
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="normalText">
                                                                    Do you have your Technical/Vocational/Business school details?
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="normalText">
                                                                    Supporting Documents: Resume/Cover Letter
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="normalText">
                                                                    Application Related Trainings: License/Certificate
                                                                </p>
                                                            </li>
                                                        </ul>
                                                    </ul>
                                                </li>

                                                <li className="title mb-3">
                                                    You&apos;re in the home stretch now.
                                                    <p className="normalText">
                                                        The last bit of information required to submit your application is any additional training and skills that are unique to the position,
                                                        also listed all references you have and lastly your initials to indicate that you are who you are!
                                                    </p>
                                                </li>
                                                <li className="title">
                                                    <p className="title list-spacing">
                                                        Applying to Multiple Positions.
                                                    </p>
                                                    <p className="normalText m-0">
                                                        All the information you entered in the previous steps will be saved and auto-populated moving forward. If you need to make any modifications or updates, you will be prompted to do so after clicking &quot;Apply&quot;.
                                                        <p className="fst-italic fw-bold">
                                                            You will need to review your information each time you apply for a position.
                                                        </p>
                                                    </p>
                                                </li>
                                            </ol>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            <p className="title">To view the status.</p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <p className="title">View your application status.</p>
                                            <p className="m-0">
                                                Follow this link to view the status of your submitted applications: <a target="_blank" rel="noopen noreferrer" href="/application">Application Status Page</a>
                                            </p>
                                            <p>
                                                If you have any questions, concerns, or need additional details please reach out to the DPM Recruitment Team.
                                            </p>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="pt-3 pb-3">
                    <Col>
                        <Card>
                            <Card.Body>
                                <Accordion>
                                    <h3 className="border-bottom border-warning border-5">Support Questions:</h3>
                                    <p className="title text-center">
                                        Please Note:&nbsp;
                                        <span className="normalText">
                                            This site utilized JavaScript, please enable JavaScript and update your browser if you are experiencing any issues.
                                        </span>
                                    </p>
                                    <h5 className="title text-center mb-2 text-warning">
                                        The recommended browser to use for this site is Google Chrome.
                                    </h5>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            <p className="title">
                                                How to upload a file onto your Profile page?
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <p className="title">
                                                Uploading Document on Desktop
                                            </p>
                                            <p>
                                                On the profile page, you will need to upload a file for the fields that require additional verification.
                                                This will allow the recruitment team to assess your provided credentials and apply appropriate credit for the information provided.
                                            </p>
                                            <ol>
                                                <p className="title">
                                                    Getting started:&nbsp;
                                                    <span className="normalText">
                                                        The accepted file formats will be PDF and image files (.pdf, .png, .jpg, .jpegs).
                                                    </span>
                                                </p>
                                                <p className="normalText mb-2">
                                                    For this example, we will use the following field:&nbsp;
                                                    <span className="title">
                                                        {"\"Are you an enrolled member of the Navajo tribe?\""}
                                                    </span>
                                                </p>
                                                <li>
                                                    {"When \"Yes\" is selected you will also be asked to provide your Census number."}
                                                </li>
                                                <li>
                                                    An Upload button will appear, once clicked you will be asked to select an image or pdf file from your current device.
                                                    Please use your devices file browser to locate the appropriate files.
                                                </li>
                                                <li>
                                                    Once the items have been inserted you can continue forward with filling out or updating your profile.
                                                </li>
                                                <li>
                                                    As you finished up with updating information you will continue to the next section and a successful save will upload the selected files.
                                                </li>
                                            </ol>
                                            <hr></hr>
                                            <p className="title">Uploading Documents on Mobile</p>
                                            <p>
                                                Most smartphones include a camera and taking a picture will be the easiest way to upload an image.
                                            </p>
                                            <ol>
                                                <p className="title">
                                                    Getting started:
                                                </p>
                                                <p className="normalText mb-2">
                                                    For this example, we will use the following field:&nbsp;
                                                    <span className="title">
                                                        {"\"Are you an enrolled member of the Navajo tribe?\""}
                                                    </span>
                                                </p>
                                                <li>
                                                    {"When \"Yes\" is selected you will also be asked to provide your Census number."}
                                                </li>
                                                <li>
                                                    <p className="m-0">
                                                        An Upload button will appear, once tapped you will be asked to {"\"Choose a photo from your library\", \"Take a new photo\", or \"Select an image or pdf file from your current device\""}.
                                                        <br></br>
                                                        <span className="title m-0">NOTE:&nbsp;</span>The simplest methods will be to {"\"Choose a photo from your library\" or \"to Take a new photo\""}.
                                                    </p>
                                                </li>
                                                <li>
                                                    Once you have taken a picture of the appropriate document, in this case a CIB, you can continue forward with filling out or updating your profile.
                                                </li>
                                                <li>
                                                    As you finished up with updating information you will continue to the next section and a successful save will upload the selected files.
                                                </li>
                                            </ol>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            <p className="title">
                                                What happens if I forget my password?
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <p className="title">To reset your password</p>
                                            <p>Follow the link to the signin page: <a target="_blank" rel="noopen noreferrer" href="/signin">Signin page</a></p>
                                            <ol>
                                                <li>
                                                    Once you are on the signin page you will choose the {"\"Forgot Password?\""} option on the bottom right of the menu.
                                                </li>
                                                <li>
                                                    Once clicked you will be prompted to enter your email linked to your account.
                                                </li>
                                                <li>
                                                    <p className="m-0">
                                                        After entering the email to your account, you will receive an email with a link to reset your password.
                                                    </p>
                                                    <p className="m-0">
                                                        Please understand that the link will be valid for only 15 minutes. If you did not use the link in a timely fashion you will have to repeat the steps above.
                                                    </p>
                                                </li>
                                                <li>
                                                    Once you have reset your password, you should signin and to make sure that the changes were properly reflected.
                                                </li>
                                            </ol>
                                            <p className="m-0"><span className="title">NOTE:&nbsp;</span>You will require access to the email associated with your account.</p>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>
                                            <p className="title">
                                                What if I don’t remember my email that I registered with?
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <p className="title">If you lost access to the email that you created your account with.</p>
                                            <p>
                                                Follow the link to the signup page: <a target="_blank" rel="noopen noreferrer" href="/signup">Signup page</a>
                                            </p>
                                            <p className="m-0">
                                                You will need to create a new account with an email you have access to.
                                            </p>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="pb-3">
                    <Col>
                        <Card>
                            <Card.Body>
                                <Accordion>
                                    <h3 className="border-bottom border-warning border-5">Recruitment Process:</h3>
                                    <p className="text-center">In general, the Navajo Nation employment process will ensure competitive practices in recruitment, selection, and placement of qualified applicants
                                        for employment with the Nation. The employment process shall comply with applicable laws of the Navajo Nation including the Navajo Preference in
                                        Employment and Personnel Policies Manual.</p>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            <p className="title">
                                                How long does the hiring process take?
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            Generally, the hiring process takes about two weeks or less.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            <p className="title">
                                                What are the required documents needed to apply?
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <p>
                                                The applicant will be responsible for creating an online applicant profile. Documents needed include Navajo Nation Certificate
                                                of Indian Blood (if the applicant is Navajo. This is used for Navajo preference).
                                            </p>
                                            <p>
                                                Other information helpful to include are copies of educational credentials (degree(s), transcripts), Valid {"driver's"} license,
                                                identification card, certificates, licensures respective to the position the applicant is applying for.
                                            </p>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            <p className="title">
                                                What time does the application submittal close?
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            Positions are advertised for ten (10) working days and are listed on the Navajo Nation Job Vacancy Announcement (JVA). Each position
                                            has a closing date, which applications must be submitted by the close of business (5pm MST) on the date indicated.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>
                                            <p className="title">
                                                Can I apply if I am Non-Navajo?
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            Yes, the Navajo Nation welcomes all interested applicants to apply. The Navajo Nation follows the Navajo Nation Employment Act in qualified referral order.
                                            <ul>
                                                <li className="list-spacing">
                                                    Priority 1: Qualified Navajo Nation Executive/Legislative Reduction Enforcement employees up to six months. Must attach REF notification.
                                                </li>
                                                <li className="list-spacing">
                                                    Priority 2: Qualified Veterans Preference Must include DD214 & Veterans Preference
                                                </li>
                                                <li className="list-spacing">
                                                    Priority 3: Qualified Navajos Must include Certificate of Indian Blood to obtain the Navajo Preference
                                                </li>
                                                <li className="list-spacing">
                                                    Priority 4: Qualified Non-Navajo Spouse - Must Provide copy of Marriage License, Navajo {"Spouse's"} Certificate of Indian Blood, Affidavit of Navajo Residence.
                                                </li>
                                                <li className="list-spacing">
                                                    Priority 5: Qualified Non-Navajos.
                                                </li>
                                            </ul>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>
                                            <p className="title">
                                                How does the Navajo Nation treat cases if the applicant has more experience and education than the minimum qualification?
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            Pursuant to the NNPPM, the qualified applicant can request an above salary assessment to counter offer the initial step A. If, the department
                                            has the budget the department can request an above salary assessment to the DPM Classification and Pay Section.  If, the {"applicant's"} education
                                            and experience exceed the minimum qualifications, a recommendation of above entry will be returned to the program via memorandum.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="5">
                                        <Accordion.Header>
                                            <p className="title">
                                                What is the hiring process of the Navajo Nation?
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            The process entails the following:
                                            <ol>
                                                <li className="list-spacing">
                                                    Applicant submits application.
                                                </li>
                                                <li className="list-spacing">
                                                    Application qualification assessment occurs against the minimum qualification.
                                                </li>
                                                <li className="list-spacing">
                                                    Qualification determination sent to the applicant.
                                                </li>
                                                <li className="list-spacing">
                                                    Non-qualified applicant may appeal within 10 working days.
                                                </li>
                                                <li className="list-spacing">
                                                    Qualified applicants are referred with respect to the NNPEA order of qualified candidates to the department for interview.
                                                </li>
                                                <li className="list-spacing">
                                                    Department schedules interview and makes hiring selection.
                                                </li>
                                                <li className="list-spacing">
                                                    Department prepares hiring documents and submits to DPM for processing.
                                                </li>
                                            </ol>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container >
        </>
    )
}

